<div class="filters-container au-filters m-b-sm">
	<form class="filters" [formGroup]="formGroupFilters">
		<mat-form-field hideRequiredMarker>
			<mat-select
				[placeholder]="firstSelectConfig.placeholder"
				[formControlName]="firstSelectConfig.formControlName"
				[multiple]="!firstSelectConfig.disableMultipleSelection"
			>
				@if (!!firstSelectConfig.checkAllPlaceholder) {
					<au-select-check-all
						[model]="formGroupFilters.get(firstFormControlName)"
						[values]="firstSelectDefaultValue"
						[text]="firstSelectConfig.checkAllPlaceholder | translate"
					>
					</au-select-check-all>
				}
				@if (
					!firstSelectConfig.disableMultipleSelection && isAllFirstSelectItemsSelected
				) {
					<mat-select-trigger>
						<span>
							{{ firstSelectConfig.checkAllPlaceholder | translate }}
						</span>
					</mat-select-trigger>
				}
				@for (item of firstSelectEntitiesList; track item) {
					<mat-option [value]="item.id">
						{{ item.name | translate }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field hideRequiredMarker>
			<mat-select
				[placeholder]="secondSelectConfig.placeholder"
				[formControlName]="secondSelectConfig.formControlName"
				[multiple]="!secondSelectConfig.disableMultipleSelection"
			>
				@if (!!secondSelectConfig.checkAllPlaceholder) {
					<au-select-check-all
						[model]="formGroupFilters.get(secondFormControlName)"
						[values]="secondSelectDefaultValue"
						[text]="secondSelectConfig.checkAllPlaceholder | translate"
					>
					</au-select-check-all>
				}
				@if (isAllSecondSelectItemsSelected) {
					<mat-select-trigger>
						<span>
							{{ secondSelectConfig.checkAllPlaceholder | translate }}
						</span>
					</mat-select-trigger>
				}
				@for (item of secondSelectEntitiesList; track item) {
					<mat-option [value]="item.id">
						{{ item.name | translate }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field hideRequiredMarker class="au-search-input">
			<input
				formControlName="search"
				autocomplete="off"
				type="text"
				matInput
				placeholder="{{ 'quick_search' | translate }}"
			/>
			<mat-icon matSuffix class="magnifier-icon">search</mat-icon>
		</mat-form-field>
	</form>
</div>
